<template>

  <tr v-if="isView!='1'" v-bind:class="{ cssHighlight: row.item['highlight'] }">
    <td class="fixed">{{row.item["numberDay"]}}</td>
    <td class="fixed2">{{row.item["shrimpAge"]}}</td>
    <td :key="`material-${material.materialId}`" style="text-align: center; width: 20px" v-for="(material, index) in lstMaterial">
      <input :data-colnumber="index"
             :data-group="group"
             :data-rownumber="row.index"
             :id="group != '' ? (group + '_' + row.index + '_' + index) : false"
             @keydown="keyProcessLocal"
             ref="day"
             type="number"
             v-model="row.item[material.materialId]"
      />
    </td>
  </tr>
  <tr v-else v-bind:class="{ cssHighlight: row.item['highlight'] }">
    <td class="fixed">{{row.item["numberDay"]}}</td>
    <td class="fixed2">{{row.item["shrimpAge"]}}</td>
    <td style="text-align: center; width: 20px" v-for="material in lstMaterial">
      {{row.item[material.materialId]}}
    </td>
  </tr>

</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "ProcedureWhDayListItem",
    props: {
      row: {
        type: Object,
        default: () => {
                    return {}
                }
      },
      group: {
        type: String,
        default: '',
      },
      rowNumber: {
        type: Number,
        default: 0,
      },

    },
    data: () => ({
      highlight : 0,
    }),
    computed: {
      ...mapGetters({
        isView: 'procedureWh/isView',
      }),
      ...mapGetters({
        lstMaterial: 'procedureWh/lstMaterial',
      }),

    },
    watch: {
      row: {
        handler(val) {
          if (val != undefined && val.item != undefined) {

            if (val.item.pongTypeId == 1) {
              this.updateMotherDay(val.index, val.item);
            } else {
              this.updateChildrenDay(val.index, val.item);
            }

          }

        },
        deep: true
      }

    },
    methods: {
      updateMotherDay(index, item) {
        this.$store.commit("procedureWh/updateMotherDay", {index, item});
      },
      updateChildrenDay(index, item) {
        this.$store.commit("procedureWh/updateChildrenDay", {index, item});
      },
      keyProcessLocal($event) {
        this.$emit("keyProcess", $event);
      }
    }
  }
</script>

<style scoped>
.cssHighlight {
  color: red;
}
</style>